import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ZoneService from "../../../services/Zone";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
const SocieteZoneTable = ({ listZones, idZone }) => {
  const [zones, setZones] = useState([]);
  const navigate = useNavigate()
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            handleDeleteZone((row.id))


            // setClients(clients.filter((dept) => dept.id !== cell));
          }}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-trash"></i>
            </small>
          </h6>
        </button>
      </span>
    );

  }
  useEffect(() => {
    console.log(listZones)
    setZones(listZones)
  }, [listZones])
  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "matricule",
      text: "Matricule",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "title",
      text: "Title",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "adresse",
      text: "Adresse",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "50%" };
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "commercialList",
    //   text: "Responsable List",
    //   align: "center",
    //   headerAlign: "center",
    // },
    // {
    //   dataField: "id",
    //   text: "Societe",
    //   formatter: (cell, row) => (

    //     <button
    //       className="btn btn-danger"
    //       onClick={() => handleSowSocietzeZone(row.id)}
    //     >
    //       <i className="fas fa-eye"></i>
    //     </button>


    //   ),
    //   align: "center",
    //   headerAlign: "center",
    // },
    // {
    //   dataField: "id",
    //   text: "Action",
    //   formatter: (cell, row) => (
    //     <button
    //       className="btn btn-danger"
    //       onClick={() => handleDeleteZone(row.id)}
    //     >
    //       <i className="fas fa-trash"></i>
    //     </button>
    //   ),
    //   align: "center",
    //   headerAlign: "center",
    // },
  ];
  const handleDeleteZone = async (idZoneClient) => {
    try {
      // Make the API call to delete the zone
      const response = await ZoneService.deleteUserZone(idZone, getCurrentUserId(), idZoneClient, 1);

      if (response.data.success) {
        // Update the state only after successful deletion
        setZones(zones.filter((zone) => zone.id !== idZoneClient));
        setOpenInfoAlert(true);

        setInfoAlertText("Element supprimé avec succée ");

      } else {
        // Handle unexpected responses from the server
        console.error("Deletion failed:", response.data.message || "Unknown error");
      }
    } catch (error) {
      // Log and handle any errors during the API call
      console.error("Error deleting zone:", error);
      setInfoAlertText("Failed to delete the zone. Please try again.");
      setOpenInfoAlert(true);
    }
  };
  const handleSowSocietzeZone = (id) => {
    navigate(`/SocieteByZone?id=${id}`)
  }
  const handleInfoClose = () => {
    setOpenInfoAlert(false);
  };

  const options = {
    paginationSize: 5,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
    ],
  };

  return (
    <div className="card mt-5">
      <div className="card-header">
        <h3 className="card-title">Societe</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={zones}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row mb-3">
                <div className="col">
                  <SearchBar
                    {...props.searchProps}
                    placeholder="Search zones..."
                  />
                </div>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
              />
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default SocieteZoneTable;
